module.exports = __webpack_public_path__ + "static/media/2bcom-online-Service-icon-4.8f1080d8.png";